import { render, staticRenderFns } from "./BorderedContainer.vue?vue&type=template&id=1d93def4&scoped=true"
import script from "./BorderedContainer.vue?vue&type=script&lang=js"
export * from "./BorderedContainer.vue?vue&type=script&lang=js"
import style0 from "./BorderedContainer.vue?vue&type=style&index=0&id=1d93def4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d93def4",
  null
  
)

export default component.exports